import { useState } from 'react';
import {
	ApplicationSummary,
	Pagination,
	PagingConfig,
} from '../../../../shared/VolunteerApplicationServiceTypes';
import { Button, Table } from 'antd';
import { TableRowSelection } from 'antd/es/table/interface';
import { useTranslation } from 'react-i18next';
import { ElgibleCandidatesTableColumns } from './EligibleCandidatesTableColumns';
import { tablePaginationConfiguration } from '../../../../shared/Utils';

interface EligibleCandidatesTableProps {
	applicationSummary: ApplicationSummary[];
	pagination: Pagination;
	paging: PagingConfig;
	onPageChange: (page: number, pageSize: number) => void;
	onSubmitClick?: () => void;
	setEligibleCandidatesIds?: React.Dispatch<
		React.SetStateAction<number[] | undefined>
	>;
}

export const EligibleCandidatesTable = (
	props: EligibleCandidatesTableProps
) => {
	const {
		applicationSummary,
		pagination,
		paging,
		onSubmitClick,
		setEligibleCandidatesIds,
		onPageChange,
	} = props;
	const { t } = useTranslation();
	const columns = ElgibleCandidatesTableColumns();

	const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
	const [isSelectedEligibleCandidates, setSelectedEligibleCandidates] =
		useState(false);

	const tablePaginationConfig = tablePaginationConfiguration(
		paging,
		pagination,
		onPageChange
	);

	const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
		setSelectedRowKeys(newSelectedRowKeys);
		if (newSelectedRowKeys.length > 0) {
			setSelectedEligibleCandidates(true);
		} else {
			setSelectedEligibleCandidates(false);
		}
		const eligibleCandidatesArrayIds = newSelectedRowKeys.map(Number);
		if (setEligibleCandidatesIds) {
			setEligibleCandidatesIds(eligibleCandidatesArrayIds);
		}
	};

	const rowSelection: TableRowSelection<ApplicationSummary> = {
		selectedRowKeys,
		onChange: onSelectChange,
		preserveSelectedRowKeys: true,
	};

	return (
		<>
			<Table
				rowKey={(record) => record.applicationId}
				rowSelection={{ type: 'checkbox', ...rowSelection }}
				dataSource={applicationSummary}
				columns={columns}
				scroll={{ x: 'max-content' }}
				pagination={tablePaginationConfig}
			/>
			<div className="flex justify-end gap-4">
				<Button
					className={`hidden md:block font-sans font-bold text-sm mt-0.5`}
					type="primary"
					onClick={onSubmitClick}
					disabled={!isSelectedEligibleCandidates}
				>
					{t('allow')}
				</Button>
			</div>
		</>
	);
};
